(function () {
  'use strict';

  function blockInvalidCheckout(event) {
    var form = event.target && event.target.closest ? event.target.closest('[data-smart-cart-form]') : null;
    if (!form) return;

    var blockedButton = form.querySelector('[data-smart-checkout-blocked]');
    if (!blockedButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    blockedButton.focus({ preventScroll: false });
  }

  document.addEventListener('submit', blockInvalidCheckout, true);
  document.addEventListener('click', function (event) {
    var checkout = event.target && event.target.closest ? event.target.closest('[data-smart-checkout-blocked]') : null;
    if (!checkout) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();
